const locationSearch = document.querySelector('.js-location-search');
const locationParams = new URLSearchParams(document.location.search);
const locationSearchAddress = locationParams.get('address');
if(locationSearch && null !== locationSearchAddress) {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAkUpfLRM4twBM56RpzRz8RGQLEQl9D4LY&libraries=geometry,places&callback=initialize';
    document.body.appendChild(script);

    function initialize() {
        let searchInput = document.getElementById('loc-search-field');
        let resultContainer = document.getElementById('loc-search-result');

        function findClosestLocation(address) {
            var geocoder = new google.maps.Geocoder();
            geocoder.geocode({
                'address': address
            }, async function (results, status) {
                // console.log("geocoder created");
                if (status == google.maps.GeocoderStatus.OK) {
                    console.log("Address Found");
                    searchInput.value = address;

                    coords = results[0].geometry.location;
                    // console.log(coords);
                    let allLocations = document.querySelectorAll(".js-location");
                    await setGeoDistances(coords.lat(), coords.lng(), allLocations);
                    let sortedLocations = await fetchAndSortDistances(allLocations);
                    // console.log(sortedLocations[0]);
                    renderClosestLocation(sortedLocations[0], resultContainer);
                    return true;
                } else if(address == "") {
                    console.log("No Address Provided");
                    return false;
                } else {
                    console.log("Address Not Found");
                    searchInput.value = "Address Not Found";
                    return false;
                }
            });
        }

        findClosestLocation(locationSearchAddress);
    }

    function setGeoDistances(addressLat, addressLon, locationList) {
        // Get distance from address for each branch.
        locationList.forEach(function (location) {
            if(location.getAttribute("data-latlng") != null && location.getAttribute("data-latlng").indexOf(",") != -1) {
                var sp = location.getAttribute('data-latlng').split(',');
                lat = Number(sp[0].replace(/[^0-9\.\-]+/gmi, '').trim());
                lng = Number(sp[1].replace(/[^0-9\.\-]+/gmi, '').trim());
                dist = calculateGeoDistance(addressLat, addressLon, lat, lng);
                location.setAttribute('data-distance', dist);
            }
        });
    }

    function calculateGeoDistance(lat1, lng1, lat2, lng2) {
        // Use a set of lat and lng from 2 locations to calculate the distance between them.
        if((lat1 == lat2) && (lng1 == lng2)) {
            return 0;
        } else {
            var radlat1 = Math.PI * lat1 / 180;
            var radlat2 = Math.PI * lat2 / 180;
            var theta = lng1 - lng2;
            var radtheta = Math.PI * theta / 180;
            var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
            if(dist > 1) {
                dist = 1;
            }
            dist = Math.acos(dist);
            dist = dist * 180 / Math.PI;
            dist = dist * 60 * 1.1515;
            return dist;
        }
    }

    function fetchAndSortDistances(locationList) {
        const branchArray = [...locationList];
        branchArray.sort(function (a, b) { return a.dataset.distance - b.dataset.distance });

        branchArray.forEach((branch, index) => {
            let formattedDistance = Math.floor(Number(branch.dataset.distance) * 100) / 100;
        });
        return branchArray;
    }

    function renderClosestLocation(sourceLocationElement, resultContainerElement) {
        let locationResult = document.createElement('div');
        locationResult.classList.add('closest-location')
        locationResult.innerHTML = "";

        locationResult.innerHTML += `<h2 class="headline">Closest Branch based off your search:</h2>
        <div class="pad">
            <p class="photo">${sourceLocationElement.querySelector(".photo").innerHTML}</p>
            <div class="details">
                <p class="distance">${Number.parseFloat(sourceLocationElement.dataset.distance).toFixed(1)} Miles Away</p>
                <p class="name">${sourceLocationElement.querySelector(".name").innerHTML}</p>
                <p class="address">${sourceLocationElement.querySelector(".address").innerHTML}</p>
                <p class="phone">${sourceLocationElement.querySelector(".phone").innerHTML}</p>
                <ul class="actions">
                    ${sourceLocationElement.querySelector(".actions").innerHTML}
                </ul>
            </div>
        </div>`;

        resultContainerElement.appendChild(locationResult);
    }
}